export default __webpack_public_path__ + "static/media/003.cc501332.jpg";